import { ExportCurve } from "iconsax-react";
import { FC, } from "react";
import { Link } from "react-router-dom";
import { ApplyNow, Login, Signin, UploadResume } from "../../../constants";
import { routes } from "../../../routers/routes";
import { HeaderType } from "../../../types/Layout";

const JobApply: FC<HeaderType> = ({ part }) => {
  const isLogin = ["job-2", "job-3"].some((item) => part?.includes(item));

  return (
    <>
      {isLogin && (
        <>
          <Link to={routes.Pages.Other.Login1} className="white-text-btn">
            {part?.includes("job-2") ? Login : Signin}
          </Link>
          <Link to={routes.Pages.Other.ContactUs1} className={part?.includes("job-2") ? "btn-pills pills-sm" : "btn-solid"}>
            {part?.includes("job-2") ? (
              ApplyNow
            ) : (
              <>
                {UploadResume}
                <ExportCurve className="iconsax" />
              </>
            )}
          </Link>
        </>
      )}
    </>
  );
};

export default JobApply;
